// Serializes schedule mutations (add / remove) and the session refresh that
// follows each one.
//
// WHY: nuxt-auth-utils' useUserSession().fetch() is literally
//   sessionState.value = await $fetch('/api/_auth/session')
// with no ordering guard — it is last-RESOLVED-wins, not last-ISSUED-wins.
// Every card's remove handler owns its own `busy` ref, so four fast clicks fire
// four overlapping `mutate(); await refreshSession()` chains. If an early
// request resolves late (ordinary network jitter), it overwrites `user.scheduled`
// with an older snapshot and the removed sessions pop back into the UI. D1 and
// the session cookie are correct throughout, which is why a reload "fixes" it.
//
// Running one mutation at a time means only one /api/_auth/session read is ever
// in flight, so a stale response cannot win. The UI stays responsive because the
// cards flip optimistically before their turn in the queue.
//
// The chain is module-scoped so every card shares it. It is only ever touched
// from a click handler (client-side), so it never leaks across SSR requests.
let tail = Promise.resolve();

// Test seam — module state would otherwise bleed between test cases.
export function __resetScheduleQueue() {
    tail = Promise.resolve();
}

export function useScheduleQueue() {
    const enqueue = (task) => {
        // `.then(task, task)` so a rejected predecessor still lets the next task
        // run — one failed remove must not wedge the queue forever.
        const run = tail.then(task, task);
        // The caller gets `run` (and its rejection); the chain swallows it so the
        // tail never becomes a permanently-rejected promise.
        tail = run.then(() => {}, () => {});
        return run;
    };

    return { enqueue };
}
